export const COUNTRY_FIELDS_HIDDEN = {
  NZ: ['countryOfIssue', 'terms'],
}
